import type { IconProps } from '../types/IconProps.ts';
export const PoundSterling: IconProps = {
    name: 'PoundSterling',
    children: [
        `<path d="M18 9V7a4 4 0 0 0-8 0v14M6 21h12M6 14h10" />`,
    ]
};